import { useMe } from '../../Configs/PolStore';
import { UserTypeDto } from '../../Models/Users/Me';
import { MeState } from '../../Services/Me/MeReducer';

export const useIsBoUser = () => {
    const me: MeState = useMe();
    return me.data?.type === UserTypeDto.BoUserAsStore || me.data?.type === UserTypeDto.BoUserAsCustomer;
};
